import type { SesionActiva } from '@shared/types';
import { esWeb } from '@renderer/lib/entorno';
import { MARCA_PESTANA } from '@renderer/store/useSessionStore';

/**
 * Sprint 166 — Al recargar, seguir dentro.
 *
 * El servidor siempre supo quién estaba dentro (la cookie firmada de la sesión, `/api/auth/me`), pero la
 * pantalla nunca se lo preguntaba al abrirse: cada recarga mandaba a la dueña a teclear su PIN. Por eso
 * no recargaba, y por eso el 24/10 vendió toda la tarde con la versión de las 12:42 (sin el freno de la
 * carga diaria). Ahora, al abrir, se pregunta; si la sesión sigue vigente, se entra directo a la misma
 * pantalla.
 *
 * Candados (auditoría `cyber` S166): sólo en la MISMA pestaña que ya entró (marca en sessionStorage:
 * cerrar el navegador o abrir otra pestaña pide PIN); "Salir" quita la marca y la cookie del navegador;
 * y el servidor revisa en la base que el usuario siga activo y con el mismo puesto (`/api/auth/me`).
 * Pendiente (DT-182): revocar en el servidor un token emitido (hoy vence a las 12 h).
 */
export async function sesionGuardada(): Promise<SesionActiva | null> {
  if (!esWeb()) return null;
  try {
    if (sessionStorage.getItem(MARCA_PESTANA) !== '1') return null;
    const r = await fetch('/api/auth/me', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(4000) });
    if (!r.ok) return null;
    const d = (await r.json()) as { sesion?: Partial<SesionActiva> | null };
    const s = d?.sesion;
    if (!s || typeof s.usuarioId !== 'number' || typeof s.nombre !== 'string' || typeof s.rol !== 'string') return null;
    return s as SesionActiva;
  } catch {
    return null; // sin red: se pide el PIN como siempre
  }
}
